import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20291951"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box user-header" }
const _hoisted_2 = { class: "user-details" }
const _hoisted_3 = { class: "user-name" }
const _hoisted_4 = { class: "user-stats" }
const _hoisted_5 = { class: "user-stat" }
const _hoisted_6 = { class: "stat-number" }
const _hoisted_7 = { class: "stat-label" }
const _hoisted_8 = { class: "user-stat" }
const _hoisted_9 = { class: "stat-label" }
const _hoisted_10 = { class: "user-stat hide-small" }
const _hoisted_11 = { class: "stat-number" }
const _hoisted_12 = { class: "stat-label" }

import { computed, ComputedRef, toRefs } from 'vue'

  import UserPicture from '@/components/User/UserPicture.vue'
  import { AUTH_USER_STORE } from '@/store/constants'
  import { IAuthUserProfile, IUserProfile } from '@/types/user'
  import { useStore } from '@/use/useStore'

  interface Props {
    user: IUserProfile
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    user: null
  },
  setup(__props: any) {

const props = __props as {
    user: IUserProfile
  }

  

  const { user } = toRefs(props)

  const store = useStore()

  const authUser: ComputedRef<IAuthUserProfile> = computed(
    () => store.getters[AUTH_USER_STORE.GETTERS.AUTH_USER_PROFILE]
  )

return (_ctx: any,_cache: any) => {
  const _component_Distance = _resolveComponent("Distance")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(UserPicture, { user: _unref(user) }, null, 8, ["user"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(user).username), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(user).nb_workouts), 1),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('workouts.WORKOUT', _unref(user).nb_workouts)), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Distance, {
            distance: _unref(user).total_distance,
            unitFrom: "km",
            digits: 0,
            displayUnit: false,
            useImperialUnits: _unref(authUser).imperial_units
          }, null, 8, ["distance", "useImperialUnits"]),
          _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(authUser).imperial_units ? 'miles' : 'km'), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(user).nb_sports), 1),
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('workouts.SPORT', _unref(user).nb_sports)), 1)
        ])
      ])
    ])
  ]))
}
}

})